<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button @click="$router.back()" type="danger" style="margin-right: 10px" icon="el-icon-back"></el-button>
      <el-date-picker
          v-model="choiceDate"
          type="month" value-format="yyyy-MM"
          placeholder="请选择日期"
      />
      <el-cascader collapse-tags style="width: 210px;margin: 0 10px" ref="cascaderRef" placeholder="请选择人员"
                   :options="deptUserTree" v-model="choiceUser"
                   :props="{ multiple: true,label:'name',value:'id'}"></el-cascader>
      <el-select v-model="tableQuery.groupIdList" filterable placeholder="请选择考勤组" multiple  collapse-tags style="margin-right: 10px">
        <el-option v-for="item in attendanceGroup" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button :loading="tableQuery.tableLoading" type="danger" @click="selectTable">搜 索</el-button>
      <el-button type="danger" @click="exportFile">导 出</el-button>
    </div>
    <el-table :data="tableData.resultMap" class="table" height="615px" border v-loading="tableQuery.tableLoading">
      <el-table-column prop="coachName" show-overflow-tooltip label="姓名" width="100"/>
      <el-table-column prop="deptName" show-overflow-tooltip label="部门" width="180"/>
      <el-table-column prop="groupName" show-overflow-tooltip label="考勤组" width="200"/>
      <el-table-column prop="date" show-overflow-tooltip label="时间" width="160"/>
      <el-table-column prop="classStr" show-overflow-tooltip label="考勤班次" width="200"/>

      <el-table-column label="班次一" align="center">
        <el-table-column show-overflow-tooltip label="上班打卡" width="180">
          <template #default="scope">
            <div v-if="scope.row.clockInTo0 || scope.row.clockResultTo0" style="width: 100%;display: flex">
              <div style="width: 44px;height: 20px;">{{scope.row.clockInTo0}}</div>
              <div style="margin-right: 10px">:</div>
              <div>{{scope.row.clockResultTo0}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="下班打卡" width="180">
          <template #default="scope">
            <div v-if="scope.row.clockInOff0 || scope.row.clockResultOff0" style="width: 100%;display: flex">
              <div style="width: 44px;height: 20px;">{{scope.row.clockInOff0}}</div>
              <div style="margin-right: 10px">:</div>
              <div>{{scope.row.clockResultOff0}}</div>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="班次二" align="center">
        <el-table-column show-overflow-tooltip label="上班打卡" width="180">
          <template #default="scope">
            <div v-if="scope.row.clockInTo1 || scope.row.clockResultTo1" style="width: 100%;display: flex">
              <div style="width: 44px;height: 20px;">{{scope.row.clockInTo1}}</div>
              <div style="margin-right: 10px">:</div>
              <div>{{scope.row.clockResultTo1}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="下班打卡" width="180">
          <template #default="scope">
            <div v-if="scope.row.clockInOff1 || scope.row.clockResultOff1" style="width: 100%;display: flex">
              <div style="width: 44px;height: 20px;">{{scope.row.clockInOff1}}</div>
              <div style="margin-right: 10px">:</div>
              <div>{{scope.row.clockResultOff1}}</div>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="班次三" align="center">
        <el-table-column show-overflow-tooltip label="上班打卡" width="180">
          <template #default="scope">
            <div v-if="scope.row.clockInTo2 || scope.row.clockResultTo2" style="width: 100%;display: flex">
              <div style="width: 44px;height: 20px;">{{scope.row.clockInTo2}}</div>
              <div style="margin-right: 10px">:</div>
              <div>{{scope.row.clockResultTo2}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="下班打卡" width="180">
          <template #default="scope">
            <div v-if="scope.row.clockInOff2 || scope.row.clockResultOff2" style="width: 100%;display: flex">
              <div style="width: 44px;height: 20px;">{{scope.row.clockInOff2}}</div>
              <div style="margin-right: 10px">:</div>
              <div>{{scope.row.clockResultOff2}}</div>
            </div>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column prop="passApplication" show-overflow-tooltip label="关联表单" width="200"/>
      <el-table-column prop="workDay" show-overflow-tooltip label="出勤天数" width="100"/>
      <el-table-column prop="restDay" show-overflow-tooltip label="休息天数" width="100"/>
      <el-table-column prop="workTime" show-overflow-tooltip label="工作时长" width="100"/>
      <el-table-column prop="beLateCount" show-overflow-tooltip label="迟到次数" width="100"/>
      <el-table-column prop="leaveEarlyCount" show-overflow-tooltip label="早退次数" width="100"/>
      <el-table-column prop="toMissingCardCount" show-overflow-tooltip label="上班缺卡" width="100"/>
      <el-table-column prop="offMissingCardCount" show-overflow-tooltip label="下班缺卡" width="100"/>
      <el-table-column prop="absenteeCount" show-overflow-tooltip label="旷工天数" width="100"/>
      <el-table-column prop="travelFrequency" show-overflow-tooltip label="出差时长" width="100"/>
      <el-table-column prop="goOutWorkCount" show-overflow-tooltip label="外出时长" width="100"/>
      <el-table-column prop="holiday" show-overflow-tooltip label="请假" width="100"/>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="tableQuery.pageSize"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableQuery.tableTotal">
    </el-pagination>
  </div>
</template>

<script>
import {selectDayStatistics,exportDayStatistics} from '/src/api/attendance/statistics'
import {selectDeptAndUserTree} from "../../../../../api/contacts/dept";
import {selectAllAttendanceGroup} from "../../../../../api/attendance/attendanceGroup";

export default {
  name: "DayStatistics",
  data() {
    return {
      choiceDate:null,
      choiceUser:[],
      deptUserTree:[],
      attendanceGroup:[],
      tableData:{
        resultMap:[]
      },
      thisDate:[],
      tableQuery:{
        tableTotal:0,
        tableLoading:false,
        coachIdList: [],
        groupIdList: [],
        month: null,
        pageIndex: 0,
        pageSize: 1,
        year: null
      },
    }
  },
  methods:{
    changePage(index){
      this.tableQuery.pageIndex = index;
      this.selectTable();
    },
    selectTable() {
      if (this.choiceDate){
        const parts = this.choiceDate.split('-');
        this.tableQuery.year = parts[0];
        this.tableQuery.month = parts[1];
        this.tableQuery.pageSize = 1;
        if (this.choiceDate  == this.thisDate[0]+'-'+this.thisDate[1]){
          let day = this.thisDate[2];
          console.log(day)
          if (day<10){
            this.tableQuery.pageSize = parseInt(10/day);
          }
        }
      }
      this.changePeople();
      this.tableQuery.tableLoading = true;
      selectDayStatistics(this.tableQuery).then(val=>{
        this.tableQuery.tableLoading = false;
        if (val.status == 200){
          this.tableData = val.data;
          this.tableQuery.tableTotal = val.data.total;
        }
      })
    },
    exportFile(){
      if (this.choiceDate){
        const parts = this.choiceDate.split('-');
        this.tableQuery.year = parts[0];
        this.tableQuery.month = parts[1];
      }
      this.changePeople();
      this.tableQuery.tableLoading = true;
      exportDayStatistics(this.tableQuery).then(val=>{
        this.tableQuery.tableLoading = false;
        if (val.status == 200){
          let url = val.data;
          window.URL = window.URL || window.webkitURL;
          var name = url.substring(url.lastIndexOf("/") + 1, url.length);
          var xhr = new XMLHttpRequest();
          var a = document.createElement("a");
          xhr.open("GET", url, true);
          xhr.responseType = "blob";
          xhr.onload = function() {
            var file = new Blob([xhr.response], { type: "application/octet-stream" });
            a.href = window.URL.createObjectURL(file);
            a.download = name;
            a.click();
          };
          xhr.send();
        }
      })
    },
    setDefaultData(){
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      this.thisDate = [year,month,day];
      this.choiceDate = year+'-'+month;
      this.tableQuery.year = year;
      this.tableQuery.month = month;
      let query = this.$route.query;
      this.item = query.item;
    },
    changePeople(){
      let list = [];
      const ref = this.$refs.cascaderRef;
      if (ref){
        const checkedNodes = ref.getCheckedNodes();
        checkedNodes.forEach((node) => {
          if (node.data.type == 1){//只保留用户不保留部门
            list.push(node.value)
          }
        });
        this.tableQuery.coachIdList = list;
      }
    },
  },
  created() {
    this.setDefaultData();
    this.selectTable();
    selectDeptAndUserTree().then(val=>{
      if (val.status == 200){
        this.deptUserTree=val.data;
      }
    })
    selectAllAttendanceGroup().then(val=>{
      if (val.status == 200){
        this.attendanceGroup=val.data;
      }
    })
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
::v-deep .el-cascader__tags{
  width: 68%;
  flex-wrap: nowrap;
}
</style>